import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Navbar } from "@/components/nuit/Navbar";
import { Hero } from "@/components/nuit/Hero";
import { Marquee } from "@/components/nuit/Marquee";
import { Problem } from "@/components/nuit/Problem";
import { Solution } from "@/components/nuit/Solution";
import { Program } from "@/components/nuit/Program";
import { Included } from "@/components/nuit/Included";
import { Pricing } from "@/components/nuit/Pricing";
import { Testimonials } from "@/components/nuit/Testimonials";
import { FAQ } from "@/components/nuit/FAQ";
import { FinalCTA } from "@/components/nuit/FinalCTA";
import { EmailCaptureSection } from "@/components/nuit/EmailCapture";
import { Footer } from "@/components/nuit/Footer";
import MentionsLegales from "@/pages/MentionsLegales";
import CGV from "@/pages/CGV";

function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash;
      setTimeout(() => {
        document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, [location.hash]);

  return (
    <div className="App relative bg-[#0a0e1a]">
      <div className="grain-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Problem />
        <Solution />
        <Program />
        <Included />
        <Pricing />
        <Testimonials />
        <FAQ />
        <FinalCTA />
        <EmailCaptureSection />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </ReactLenis>
    </BrowserRouter>
  );
}

export default App;
